<template>
  <div
    id="AboutMeCollage3"
    style="width: 90%; padding-top: 80%; padding-bottom: 20%; translate: 1% 0%;"
  >
    <img
      fetchpriority="high"
      style="width: 45%;"
      src="/static/about-me/i12.webp"
    />
    <div style="translate: 6% 0%;">
      <img
        fetchpriority="high"
        style="width: 26%; translate: 0% -69%;"
        src="/static/about-me/i13.webp"
      />
      <StickMe name="58" size="10" left="32" top="12.5" />
      <img
        fetchpriority="high"
        style="width: 27%; translate: -31% 25%; z-index: 2;"
        src="/static/about-me/i14.webp"
      />
      <img
        fetchpriority="high"
        style="width: 18%; translate: -51% 109%;"
        src="/static/about-me/i16.webp"
      />
      <img
        fetchpriority="high"
        style="width: 23%; translate: -83% -18%;"
        src="/static/about-me/i15.webp"
      />
    </div>
    <div style="translate: -6% 25%;">
      <img
        fetchpriority="high"
        style="width: 31%; translate: -7% 47%;"
        src="/static/about-me/i18.webp"
      />
      <img
        fetchpriority="high"
        style="width: 16%; translate: 8% -12%;"
        src="/static/about-me/i17.webp"
      />
      <img
        fetchpriority="high"
        style="width: 17%; translate: 33% 3%;"
        src="/static/about-me/i19.webp"
      />
    </div>
    <div style="translate: -4% 80%;">
      <img
        fetchpriority="high"
        style="width: 14%; translate: 18% -1%; scale: 1.2;"
        src="/static/about-me/i21.webp"
      />
      <img
        fetchpriority="high"
        style="width: 23%; translate: 18% -87%;"
        src="/static/about-me/i20.webp"
      />
    </div>
    <img
      fetchpriority="high"
      style="width: 20%; translate: 34% 21%;"
      src="/static/about-me/i22.webp"
    />
    <StickMe name="17" size="16" left="11" top="0" uk-parallax="x: 40%" />
    <StickMe name="53" size="23" left="33" top="9" uk-parallax="x: 60%" />
    <StickMe name="17" size="8" left="30" top="19" uk-parallax="x: 20%" />

    <StickMe name="3" size="11" left="8" top="27" uk-parallax="x: 20%" />
    <StickMe name="54" size="28" left="53" top="32" />
    <StickMe name="3" size="16" left="32" top="35.4" uk-parallax="x: 40%" />
    <StickMe name="5" size="6" left="42" top="32" uk-parallax="x: 20%" />
    <StickMe name="17" size="6" left="66" top="28" uk-parallax="x: 20%" />
    <StickMe name="55" size="11" left="71" top="33" uk-parallax="x: 70%" />
    <StickMe name="3" size="10" left="83" top="37" uk-parallax="x: 20%" />
    <StickMe name="57" size="18" left="79" top="42" />
    <StickMe name="56" size="18" left="23" top="40.5" style="z-index: -1;" />
    <StickMe name="3" size="13" left="58" top="52" uk-parallax="x: 10%" />
    <StickMe name="13" size="15" left="57" top="56" uk-parallax="x: -10%" />
    <StickMe name="13" size="15" left="21" top="59" uk-parallax="x: 10%" />
    <StickMe name="59" size="4.5" left="26" top="61" uk-parallax="x: -10%" />
    <StickMe name="3" size="13" left="28" top="64" uk-parallax="x: 20%" />
    <StickMe name="60" size="17" left="13" top="64.8" />
    <StickMe name="61" size="11" left="52" top="61" />
    <StickMe name="62" size="10" left="74" top="61" style="z-index: -1;" />
    <StickMe name="17" size="8" left="79" top="63" uk-parallax="x: 30%" />
    <StickMe name="63" size="11" left="62" top="69" />
    <StickMe name="64" size="12" left="84" top="73" />
    <StickMe name="67" size="12" left="65" top="80" />
    <StickMe name="17" size="8" left="56" top="82" uk-parallax="x: 30%" />
    <StickMe name="66" size="10" left="46" top="81.5" />
    <StickMe name="5" size="8" left="45" top="74" uk-parallax="x: 10%" />
    <StickMe name="1" size="17" left="9" top="77" uk-parallax="x: 35%" />
    <StickMe name="65" size="17" left="25" top="84" style="z-index: -1;" />
    <StickMe name="3" size="13" left="24" top="88" uk-parallax="x: 38%" />
    <StickMe name="68" size="17" left="42" top="93" uk-parallax="x: 30%" />
    <StickMe name="70" size="5" left="48" top="91" uk-parallax="x: 30%" />
    <StickMe name="69" size="9" left="44" top="88" uk-parallax="scale: 1.2" />
    <StickMe name="59" size="4" left="78" top="85" uk-parallax="scale: 1.2" />
  </div>
</template>

<script>
import StickMe from './StickMe.vue'

export default {
  components: {
    StickMe,
  },
}
</script>



// WEBPACK FOOTER //
// src/components/about-me/AboutMeCollage3.vue